import { render, staticRenderFns } from "./DialogSiteLayout.vue?vue&type=template&id=0005fb3a&"
import script from "./DialogSiteLayout.vue?vue&type=script&lang=js&"
export * from "./DialogSiteLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports